import { useState, useEffect } from "react";
import { ImgLoader, Loader, SpeakerModal } from "./index";
import { getData } from "../utils/apiCalls";
import { tracking } from "../utils/tracking";
import { svgs } from "../assets/svgs";
import  speakers  from '../data/speakers_dyn.json'

export const SpeakerCards = ({ isSliced }) => {
   const [data, setData] = useState({})
   const [speakerIdx, setSpeakerIdx] = useState(null)
   // const [isLoading, setIsLoading] = useState(true)
   const [numOfSpeakersToDisplay, setNumOfSpeakersToDisplay] = useState(isSliced ? 20 : Infinity);

   useEffect(() => {
      setData(speakers)
      // getData(`https://youngstartup.io/api/cwebsite/get_speakers_dyn?${isSliced && 'sc=true'}&event=NYVS24`)
      //    .then(res => { setData(res) })
      //    .then(() => { setIsLoading(false) })
   }, [isSliced]);

   useEffect(() => {
   }, [numOfSpeakersToDisplay])
   const handleClose = () => setSpeakerIdx(null);
   const addMoreSpeakersToDisplay = () => {
      setNumOfSpeakersToDisplay(prev => prev + 20)
   }

   return (
      <div className='speaker-cards-container' >
         <div className='speaker-cards' >
            {/* {isLoading && <Loader />} */}
            { data?.speakers?.length > 0 &&
               <h1>
                  OUR FEATURED INVESTORS
               </h1>
            }
            { data?.speakers?.length > 0 &&
               <div className="speaker-card-container">
                  {
                     data?.speakers?.slice(0, numOfSpeakersToDisplay).map((speaker, i) =>
                        <button className="speaker-card"
                           key={i}
                           onClick={() => {
                              setSpeakerIdx(i)
                           }}
                        >
                           <ImgLoader src={speaker.speaker_head_shot_to_display} placeHolder={svgs.headshotPLaceholder} alt={`${speaker.firstname} ${speaker.lastname}, investor from ${speaker.company}, attending our event`} />
                           <h3>{speaker.firstname} {speaker.lastname}</h3>
                           <h4>{speaker.company}</h4>
                        </button>
                     )
                  }
               </div>
            }
            {
               isSliced && data?.total > 0 && numOfSpeakersToDisplay < data?.total &&
               <div className="btn-container">
                  <button onClick={() => { tracking(274); addMoreSpeakersToDisplay() }} className='btn' >
                     Show More
                  </button>
               </div>
            }
            {data?.total > 0 && numOfSpeakersToDisplay >= data?.total && <h2>More Investors to be Announced</h2>}
            {
               speakerIdx !== null &&
               <div className="modal-container" >
                  <div className="speakere-modal" >
                     <SpeakerModal speakers={data?.speakers} speakerIdx={speakerIdx} handleClose={handleClose} />
                  </div>
               </div>
            }
         </div >
      </div >
   )
}